export default __webpack_public_path__ + "static/media/d4c91e6b89beef76.3519e35b74ea902bab100532e4d1ff78.svg";